export default __webpack_public_path__ + "static/media/huobi.10dd455f.svg";